const authService = require("./auth");

async function sendContact(typeId, bodyObject) {
    //headers
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${await authService.authFront()}`);


    var requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyObject)
    };

    const req = await fetch(`${process.env.API_URL}/contact/${typeId}`.toLowerCase(), requestOptions)

    return req;

}

module.exports = {
    sendContact: sendContact
}
